<div *ngIf="device" class="mc-details-header">
  <div class="header-device-icon">
     <sa-device-icon [form]="device?.form" [complianceStatus]="device?.complianceStatus" ></sa-device-icon>

  </div>
  <div class="header-device-name">
      {{device.deviceName}}
  </div>
   <div class="header-actions">
      <a  class="header-action-btn" href="javascript:void(0)" title="{{'label_Message' | xsI18n}}" (click)="onActionClick($event, 'SendMessage')">
        <span class="ssp-icon ssp-icon-sendmessage"> </span>
      </a>
      <a  class="header-action-btn" href="javascript:void(0)" title="{{'label_CheckIn' | xsI18n}}" (click)="onActionClick($event, 'CheckIn')">
        <span class="ssp-icon ssp-icon-checkin"> </span>
      </a>
      <a class="header-action-btn" href="javascript:void(0)" title="{{'label_Lock' | xsI18n}}" (click)="onActionClick($event, 'Lock')">
        <span class="ssp-icon ssp-icon-lock2"> </span>
      </a>
      <mc-actions-menu *ngIf="device" [device]="device"></mc-actions-menu>
  </div>
</div>
